import React from 'react'
import { useTranslation } from 'react-i18next'
import PatientCopilotMetricWidget from './common/PatientCopilotMetricWidget'
import { CopilotEngagementTypes } from 'consts/copilotControlConsts'
import useEngagementsWidget from 'components/CopilotControl/components/common/EngagementWidget/useEngagementsWidget'
import Scanning from '../CopilotSettings/icons/Insights/Scanning'

const PatientScanningScoreWidget = ({ scanningScheduleScoreCategory, isLoading }) => {
  const { t } = useTranslation()

  const { scoreOptions } = useEngagementsWidget({
    engagementType: CopilotEngagementTypes.ScanningSchedule,
    values: {}
  })

  const scoreOption = scoreOptions[scanningScheduleScoreCategory]

  return (
    <PatientCopilotMetricWidget
      title={t('pages.patients.patientSidebar.items.copilot.copilotInsights.scanning.title')}
      titleIcon={<Scanning />}
      noData={scoreOption === null}
      metricLabel={scoreOption?.label}
      metricIcon={
        scoreOption?.icon &&
        React.createElement(scoreOption?.icon, {
          size: 'small',
          fillColor: scoreOption?.fillColor,
          strokeColor: scoreOption?.strokeColor
        })
      }
      labelColor={scoreOption?.strokeColor}
      isLoading={isLoading}
    />
  )
}

export default PatientScanningScoreWidget
